export default __webpack_public_path__ + "static/media/banner_tienlen-v3-mobile-2.27a5c21b.jpg";